import Nullstack from 'nullstack';
export default function IconMicrowave({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-microwave",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "6",
    width: "18",
    height: "12",
    rx: "1"
  }), "   ", Nullstack.element("path", {
    d: "M15 6v12"
  }), "   ", Nullstack.element("path", {
    d: "M18 12h.01"
  }), "   ", Nullstack.element("path", {
    d: "M18 15h.01"
  }), "   ", Nullstack.element("path", {
    d: "M18 9h.01"
  }), "   ", Nullstack.element("path", {
    d: "M6.5 10.5c1 -.667 1.5 -.667 2.5 0c.833 .347 1.667 .926 2.5 0"
  }), "   ", Nullstack.element("path", {
    d: "M6.5 13.5c1 -.667 1.5 -.667 2.5 0c.833 .347 1.667 .926 2.5 0"
  }), " ");
}